export const DEFAULT_WINDOW_SIZE = {
  width: 1000,
  height: 700
}

export const DEFAULT_WINDOW_POSITION = {
  x: 100,
  y: 100
}

export const MIN_WINDOW_SIZE = {
  width: 400,
  height: 300
}

export const MAX_Z_INDEX = 10

export enum AppGroup {
  FILES = 'files',
  OFFICE_TOOLS = 'office_tools',
  WORKFORCE_MANAGEMENT = 'workforce_management',
  COMMUNICATION = 'communication',
  BUSINESS_TOOLS = 'business_tools',
  CONFIGURATION = 'configuration'
}

export const EASE_IN_OUT: [number, number, number, number] = [0.4, 0, 0.2, 1]
